import React, { useEffect, useState, useCallback } from 'react';
import DataTable from './DataTable';
import axiosInstance from '../utils/axiosInstance';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const CompletedRequests = () => {
  const [data,    setData]    = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchApprovedRequests = useCallback(async () => {
    try {
      const response = await axiosInstance.get('/request/approved');
      setData(
        response.data
          .filter(r => r.status === 'approved')
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
      );
    } catch (e) {
      console.error(e);
      toast.error('Veriler yüklenemedi!');
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { fetchApprovedRequests(); }, [fetchApprovedRequests]);

  if (loading) return (
    <div style={{ minHeight: '100vh', background: '#090a0c', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'rgba(255,255,255,.25)', fontFamily: 'Inter,sans-serif', fontSize: '.85rem' }}>
      Yükleniyor...
    </div>
  );

  return (
    <>
      <ToastContainer theme="dark" position="top-right" />
      <DataTable
        title="Onaylanan Talepler"
        data={data}
        isPendingPage={false}
        isCompletedPage={true}
        fetchData={fetchApprovedRequests}
      />
    </>
  );
};

export default CompletedRequests;
